import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "notification-dropdown" }
const _hoisted_2 = {
  key: 1,
  class: "notifications"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_notification_detail_content = _resolveComponent("notification-detail-content")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, {
      menuOpen: _ctx.menuOpen,
      "onUpdate:menuOpen": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.menuOpen) = $event)),
      "offset-y": "",
      "onClick:outside": _ctx.closeMenu,
      onKeydown: _withKeys(_ctx.closeMenu, ["esc"]),
      "close-on-content-click": false,
      right: "",
      "z-index": _ctx.zIndex
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps(props, {
          icon: "",
          onClick: _ctx.toggleMenu
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("mdi-bell")
              ])),
              _: 1
            }),
            (_ctx.notSeenNotfCount > 0)
              ? (_openBlock(), _createBlock(_component_v_badge, {
                  key: 0,
                  color: "red",
                  overlap: ""
                }, {
                  badge: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.notSeenNotfCount), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1040, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, { class: "custom-menu-style" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, { class: "menu-header" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "7" }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode(" Notifications ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              label: "Show Viewed",
                              class: "menu-header-switch",
                              modelValue: _ctx.includeSeenNotifications,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.includeSeenNotifications) = $event)),
                              color: "success",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "menu-header text-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_linear, {
                          indeterminate: "",
                          color: "primary",
                          height: "6"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_ctx.notifications.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: `${index}_ntfitem`,
                        class: _normalizeClass(["notification-item", { dark: _ctx.isDarkTheme, 'not-seen': !_ctx.isSeen(item) }]),
                        onClick: ($event: any) => (_ctx.makeSeen(item))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_notification_detail_content, {
                            key: `${index}_ntfContent_${_ctx.notifsVersion}`,
                            item: item,
                            isTeamMember: _ctx.isTeamMember,
                            isAdmin: _ctx.isAdmin,
                            isClient: _ctx.isClient,
                            userId: _ctx.userId,
                            hasAutoUpdate: true,
                            onSuccessRaise: _ctx.successRaise,
                            onErrorRaise: _ctx.errorRaise,
                            onInitNotifications: _ctx.initNotifications,
                            onInitNotSeenNotificationsCount: _ctx.initNotSeenNotificationsCount,
                            onUpdateItemsVersion: _ctx.updateItemsVersion
                          }, null, 8, ["item", "isTeamMember", "isAdmin", "isClient", "userId", "onSuccessRaise", "onErrorRaise", "onInitNotifications", "onInitNotSeenNotificationsCount", "onUpdateItemsVersion"]))
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
            (_ctx.viewAllRoute)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 2,
                  to: _ctx.viewAllRoute,
                  class: "show-more",
                  title: "View All Notifications"
                }, null, 8, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["menuOpen", "onClick:outside", "onKeydown", "z-index"])
  ]))
}